import Grid from "@mui/material/Grid";
import MDBox from "../../../../components/MDBox";
import BookingCard from "../../../../examples/Cards/BookingCard";
import amenitiesService, {getAmenities} from "../../../../services/amenities.service";
import {useEffect, useState} from "react";
import {getUserRole} from "../../../../services/auth.service";
import MDSocialButton from "../../../../components/MDSocialButton";
import {Link} from "react-router-dom";
import Icon from "@mui/material/Icon";
import MDTypography from "../../../../components/MDTypography";


function AmenitiesList({filter}) {
    const [responseData, setResponseData] = useState([]);
    // const [sss, setSSS] = useState(false);
    const doDelete = (id) =>{
        if(window.confirm("Do you want to delete this amenity ? ")){
            amenitiesService.deleteAmenity(id)
            .then((value)=>{
                window.location.reload();
            }).catch((res)=>{

            });
        }
    }
    const doEdit = (id) =>{
        if(window.confirm("Do you want to edit this amenity ? ")){
            window.location = "/amenities/insert?id=" + id
        }
    }
    const renderAdminButton = () => {
        const currentRole = getUserRole();
        if (currentRole === "staff" || currentRole === "admin" || currentRole === "super_admin") {
        // setSSS(true);
          return (
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mt={3}>
                <MDSocialButton
                  color="tumblr"
                  size="medium"
                  fullWidth
                  component={Link}
                  to="/amenities/insert"
                >
                  <Icon color="inherit" sx={{ m: 0.5 }}>
                    add
                  </Icon>
                  Insert New Amenities
                </MDSocialButton>
              </MDBox>
            </Grid>
          );
        }
        return "";
      };
    useEffect(() => {
          getAmenities(filter)
            .then((res) => {
              console.log(res.data);
              setResponseData(res.data);

            })
            .catch((error) => {
              console.log(error);
            });
        }, [filter]);
    const renderButtons = (item) =>{
        // alert(getUserRole());
        if (getUserRole() === "super_admin"){ //  || getUserRole() === "staff"
            return (<>
                              <MDBox
                                onClick={() => doDelete(item.id)}
                                sx={{
                                    cursor: "pointer",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    borderRadius: "8px",
                                    p: 0.75,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    "&:hover": { backgroundColor: "error.main", color: "white" },
                                    transition: "all 0.2s ease",
                                }}
                              >
                                <Icon sx={{ fontSize: "1.25rem" }}>delete</Icon>
                              </MDBox>
                              <MDBox
                                onClick={() => doEdit(item.id)}
                                sx={{
                                    cursor: "pointer",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    borderRadius: "8px",
                                    p: 0.75,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    "&:hover": { backgroundColor: "info.main", color: "white" },
                                    transition: "all 0.2s ease",
                                }}
                              >
                                <Icon sx={{ fontSize: "1.25rem" }}>edit</Icon>
                              </MDBox>
                            </>)
        }else{
            return null
        }
    }
    const renderEmptyState = () => (
        <Grid item xs={12}>
            <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                py={8}
            >
                <Icon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}>event_busy</Icon>
                <MDTypography variant="h5" color="text" fontWeight="medium">
                    No Amenities Available
                </MDTypography>
                <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                    There are no amenities to display at the moment.
                </MDTypography>
            </MDBox>
        </Grid>
    );

    return (
        <Grid container spacing={4} paddingBottom={3} padding={3}>
            {renderAdminButton()}
            {responseData.length === 0 ? renderEmptyState() : responseData.map((item) => (
                <Grid item xs={12} sm={6} lg={4} xl={3} key={item.id} sx={{ display: "flex" }}>
                  <MDBox mt={2} width="100%">
                     <BookingCard
                       image={item.image}
                       title={item.name}
                       description={item.description}
                       price={item.currency + " " + item.price}
                       duration={item.period_duration + " Min"}
                       location=""
                       bookId={item.id}
                       action={renderButtons(item)}
                     />
                   </MDBox>
                </Grid>
            ))}
        </Grid>
    );
}


export default AmenitiesList;